export const vcNewPatientImages = [
  require('./../../assets/images/parents-unselected.svg'),
  require('./../../assets/images/parents-selected.svg'),
  require('./../../assets/images/children-unselected.svg'),
  require('./../../assets/images/children-selected.svg'),
  require('./../../assets/images/Invisalign-clear-aligners.png'),
  require('./../../assets/images/clearbraces.png'),
  require('./../../assets/images/RegularBraces.png'),
  require('./../../assets/images/calendar.svg'),
  require('./../../assets/images/Crowding.png'),
  require('./../../assets/images/Crowding selected.png'),
  require('./../../assets/images/Spacing.png'),
  require('./../../assets/images/Spacing selected.png'),
  require('./../../assets/images/Crossbite.png'),
  require('./../../assets/images/Crossbite selected.png'),
  require('./../../assets/images/Flared Teeth.png'),
  require('./../../assets/images/Flared Teeth selected.png'),
  require('./../../assets/images/Excessive Overbite.png'),
  require('./../../assets/images/Excessive Overbite selected.png'),
  require('./../../assets/images/Underbite.png'),
  require('./../../assets/images/Underbite selected.png'),
  require('./../../assets/images/Deepbite.png'),
  require('./../../assets/images/Deepbite selected.png'),
  require('./../../assets/images/Openbite.png'),
  require('./../../assets/images/Openbite selected.png'),
  require('./../../assets/images/Other.png'),
  require('./../../assets/images/Other selected.png'),
  require('./../../assets/images/Other selected.png'),
];
